<template>
  <div class="dashboardGrid">
    <div class="channelCard">
      <div class="channelCardTop channelColorFacebook">
        <div class="cardSubTitle">LIKES</div>
        <div class="cardMainNumber">128.283</div>
        <div class="cardGrowIndicator negative">
          <img src="../assets/images/arrow-down.png" alt="" /> 5.2%
        </div>
        <div class="cardChannelLogo">
          <img src="../assets/images/logo-facebook.png" alt="" />
        </div>
      </div>
      <div class="channelCardBottom">
        <div class="cardSubTitle">SENTIMENT</div>
        <div class="cardChannelSentimentMain">
          <div>
            <p class="cardChannelSentimentMainData positive">44%</p>
            <p class="cardChannelSentimentMainSubtitle positive">POSITIV</p>
          </div>
          <div>
            <p class="cardChannelSentimentMainData negative">56%</p>
            <p class="cardChannelSentimentMainSubtitle negative">NEGATIV</p>
          </div>
        </div>
      </div>
    </div>
    <div class="channelCard">
      <div class="channelCardTop channelColorYouTube">
        <div class="cardSubTitle">SUBSCRIBERS</div>
        <div class="cardMainNumber">32.600</div>
        <div class="cardGrowIndicator positive">
          <img src="../assets/images/arrow-up.png" alt="Positive" /> 13.8%
        </div>
        <div class="cardChannelLogo">
          <img src="../assets/images/logo-youtube.png" />
        </div>
      </div>
      <div class="channelCardBottom">
        <div class="cardSubTitle">SENTIMENT</div>
        <div class="cardChannelSentimentMain">
          <div>
            <p class="cardChannelSentimentMainData positive">64%</p>
            <p class="cardChannelSentimentMainSubtitle positive">POSITIV</p>
          </div>
          <div>
            <p class="cardChannelSentimentMainData negative">36%</p>
            <p class="cardChannelSentimentMainSubtitle negative">NEGATIV</p>
          </div>
        </div>
      </div>
    </div>
    <div class="channelCard">
      <div class="channelCardTop channelColorTwitter">
        <div class="cardSubTitle">FOLLOWERS</div>
        <div class="cardMainNumber">2.178</div>
        <div class="cardGrowIndicator positive">
          <img src="../assets/images/arrow-up.png" alt="Positive" /> 4.1%
        </div>
        <div class="cardChannelLogo">
          <img src="../assets/images/logo-twitter.png" />
        </div>
      </div>
      <div class="channelCardBottom">
        <div class="cardSubTitle">SENTIMENT</div>
        <div class="cardChannelSentimentMain">
          <div>
            <p class="cardChannelSentimentMainData positive">51%</p>
            <p class="cardChannelSentimentMainSubtitle positive">POSITIV</p>
          </div>
          <div>
            <p class="cardChannelSentimentMainData negative">49%</p>
            <p class="cardChannelSentimentMainSubtitle negative">NEGATIV</p>
          </div>
        </div>
      </div>
    </div>
    <div class="channelCard">
      <div class="channelCardTop channelColorLinkedin">
        <div class="cardSubTitle">SUBSCRIBERS</div>
        <div class="cardMainNumber">3,26K</div>
        <div class="cardGrowIndicator positive">
          <img src="../assets/images/arrow-up.png" alt="Positive" /> 1.1%
        </div>
        <div class="cardChannelLogo">
          <img src="../assets/images/logo-linkedin.png" />
        </div>
      </div>
      <div class="channelCardBottom">
        <div class="cardSubTitle">SENTIMENT</div>
        <div class="cardChannelSentimentMain">
          <div>
            <p class="cardChannelSentimentMainData positive">89%</p>
            <p class="cardChannelSentimentMainSubtitle positive">POSITIV</p>
          </div>
          <div>
            <p class="cardChannelSentimentMainData negative">11%</p>
            <p class="cardChannelSentimentMainSubtitle negative">NEGATIV</p>
          </div>
        </div>
      </div>
    </div>
    <div class="fullWithCard">
      <div class="cardSubTitle">Sentiment per kanal</div>
      <div id="chart"></div>
    </div>
    <div id="scrollToElement" class="fullWithCard">
      <div class="cardSubTitle">Sentiment och följare per position</div>
      <div class="googleMapsCard">
        <div>
          <img v-if="show[0]" src="../assets/images/maps/sentiment.png" alt="" />
          <img v-if="show[1]" src="../assets/images/maps/facebook.png" alt="" />
          <img v-if="show[2]" src="../assets/images/maps/twitter.png" alt="" />
          <img v-if="show[3]" src="../assets/images/maps/youtube.png" alt="" />
          <!-- <GoogleMaps
            :facebookPoints="facebook"
            :twitterPoints="twitter"
            :linkedinPoints="linkedin"
            :lat="63.0"
            :lng="16.0"
            :height = 800
            :weight = 600
            :zoom="5"
            :show="show"
          /> -->
        </div>
        <div class="filterDiv">
          <div style="margin-bottom: 10px;">Filter till karta</div>
          <div class="mapFilterChoose">
            <el-radio v-model="radio" label="sentiment" border size="medium" name="maptype" v-on:change="changeMap(true, false, false, false)">Sentiment</el-radio>
            <el-radio v-model="radio" label="facebook" border size="medium" name="maptype" v-on:change="changeMap(false, true, false, false)">Facebook</el-radio>
            <el-radio v-model="radio" label="twitter" border size="medium" name="maptype" v-on:change="changeMap(false, false, true, false)">Twitter</el-radio>
            <el-radio v-model="radio" label="youtube" border size="medium" name="maptype" v-on:change="changeMap(false, false, false, true)">Youtube</el-radio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
// import GoogleMaps from '../components/GoogleMaps.vue'
import * as Generator from '../components/RandomCoordinateGenerator'

let toShow = [true, false, false];

export default {
  components: {
    // GoogleMaps
  },

  data () {
    return {
      // facebook: Generator.generateDemoCoordinates(),
      // twitter: Generator.getCitiesWithPopulation(),
      // linkedin: Generator.generateDemoCoordinates(),
      show: [true, false, false, false],
      radio: 'sentiment'
    }
  },

  props: {},

  created: function () {
    // console.log(this.show)
  },

  async mounted () {
    const options = {
      chart: {
        height: 250,
        type: 'bar',
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      series: [
        {
          name: 'NEGATIV',
          data: [44, 64, 51, 89]
        },
        {
          name: 'POSITIV',
          data: [56, 36, 49, 11]
        }
      ],
      xaxis: {
        categories: ['Facebook', 'YouTube', 'Twitter', 'LinkedIn']
      },
      fill: {
        colors: ['#3CC480', '#FB362B'],
        opacity: 1
      },
      legend: {
        labels: {
          colors: ['#3CC480', '#FB362B'],
          useSeriesColors: true
        }
      }
    }

    const chart = new ApexCharts(document.querySelector('#chart'), options)
    chart.render()
  },

  methods: {
    changeMap (sentiment, facebook, twitter, youtube) {
      document.querySelector('#scrollToElement').scrollIntoView({ behavior: 'smooth' });
      this.show = [sentiment, facebook, twitter, youtube];
    }
  }
}
</script>

<style scoped>
/* .apexcharts-legend-marker, .apexcharts-legend-marker {
  color: rgb(251, 54, 43) !important;
} */
</style>
